import { createSelector } from "reselect"

const getAccount = state => state.global.selected.account
const getUserId = (state, props) => props.userId

export const getUpdateUrl = createSelector(
  [getAccount, getUserId],
  (account, userId) => `/api/${account}/users/${userId}/subscriptions`,
)
